import { Container as MuiContainer, type ContainerProps as MuiContainerProps } from '@mui/material';

export type ContainerProps = MuiContainerProps;

export const Container = (props: Readonly<ContainerProps>) => <MuiContainer {...props} />;
